import { apiService } from './api';

export interface RegistroAuditoria {
  id: number;
  empresa_id: number | null;
  user_id: number | null;
  usuario_nome: string | null;
  usuario_email: string | null;
  acao: string;
  entidade: string | null;
  entidade_id: number | null;
  descricao: string | null;
  alteracoes: Record<string, { de: unknown; para: unknown }> | null;
  ip: string | null;
  rota: string | null;
  created_at: string;
}

export interface FiltrosAuditoria {
  empresa_id?: number;
  acao?: string;
  entidade?: string;
  user_id?: number;
  data_inicio?: string;
  data_fim?: string;
  search?: string;
  page?: number;
  per_page?: number;
}

export const auditoriaService = {
  listar: async (filtros: FiltrosAuditoria = {}) => {
    const params = new URLSearchParams();
    Object.entries(filtros).forEach(([chave, valor]) => {
      if (valor !== undefined && valor !== '') params.append(chave, String(valor));
    });
    const query = params.toString();
    return apiService.get<any>(`/v1/auditoria${query ? '?' + query : ''}`);
  },

  opcoesDeFiltro: async () => {
    return apiService.get<any>('/v1/auditoria/acoes');
  },
};
